export default {
  path: "/materialManagement",
  redirect: "/materialManagement/material/supplier/list",
  meta: {
    title: "材设部",
    permissionCode: "pcMaterialDept",
  },
  children: [
    // {
    //   path: "material",
    //   redirect: "/materialManagement/material/supplier/list",
    //   meta: {
    //     title: "材料管理",
    //     permissionCode: "pcMaterial",
    //   },
    //   component: () => import("@/router/EmptyComponent.vue"),
    //   children: [

    //   ],
    // },
    {
      path: "/materialManagement/material/supplier/list",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialManagement/supplier/list/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialSupplierList",
        title: "供应商信息管理",
        name: "pcMaterialSupplierList",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/material/supplier/create",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialManagement/supplier/create/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialSupplierList",
        title: "供应商信息管理",
      },
    },
    {
      path: "/materialManagement/material/supplier/details",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialManagement/supplier/details/index.vue"
        ),
      meta: {
        //供应商详情
        title: "材料管理",

        permissionCode: "pcMaterialSupplierList",
      },
    },
    {
      path: "/materialManagement/material/brand/list",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialManagement/brand/list/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialBrandList",
        title: "品牌信息管理",
        name: "pcMaterialBrandList",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/material/brand/create",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialManagement/brand/create/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialBrandList",
        title: "品牌信息管理",
      },
    },
    {
      path: "/materialManagement/material/materialInfo/list",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialManagement/materialInfo/list/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialMaterialInfoList",
        title: "材料信息管理",
        name: "pcMaterialMaterialInfoList",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/material/materialInfo/create",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialManagement/materialInfo/create/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialMaterialInfoList",
        title: "材料信息管理",
      },
    },
    {
      path: "/materialManagement/material/baseData/list",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialManagement/baseData/list/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialBaseDataList",
        title: "基础信息配置",
        keepAlive: true,
      },
    },
    // {
    //   path: "contracts",
    //   redirect: "/materialManagement/contracts/materialContract",
    //   meta: {
    //     title: "合同管理",
    //     permissionCode: "pcMaterialContract",
    //   },
    //   component: () => import("@/router/EmptyComponent.vue"),
    //   children: [

    //   ],
    // },
    {
      path: "/materialManagement/contracts/materialContract",
      component: () =>
        import(
          "@/views/materialDesignDepartment/contracts/materialContract/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialMaterialContractList",
        title: "材料合同管理",
        name: "pcMaterialMaterialContractList",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/contracts/doubleContract",
      component: () =>
        import(
          "@/views/materialDesignDepartment/contracts/doubleContract/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialDoubleContractList",
        title: "双包合同管理",
        name: "pcMaterialDoubleContractList",
        keepAlive: true,
      },
    },
    // {
    //   path: "plan",
    //   redirect: "/materialManagement/plan/count",
    //   meta: {
    //     title: "计划管理",
    //     permissionCode: "pcMaterialPlan",
    //   },
    //   component: () => import("@/router/EmptyComponent.vue"),
    //   children: [

    //   ],
    // },
    {
      path: "/materialManagement/plan/count",
      component: () =>
        import("@/views/materialDesignDepartment/plan/count/index.vue"),
      meta: {
        permissionCode: "pcMaterialManagementPlanMain",
        title: "材料总计划",
        name: "pcMaterialManagementPlanMain",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/plan/batches",
      component: () =>
        import("@/views/materialDesignDepartment/plan/batches/index.vue"),
      meta: {
        permissionCode: "pcMaterialManagementPlanBatches",
        title: "材料分批计划",
        name: "pcMaterialManagementPlanBatches",
        keepAlive: true,
      },
    },
    // {
    //   path: "purchase",
    //   redirect: "/materialManagement/purchase/list",
    //   meta: {
    //     title: "采购管理",
    //     permissionCode: "",
    //   },
    //   component: () => import("@/router/EmptyComponent.vue"),
    //   children: [
        
    //   ],
    // },
    {
      path: "/materialManagement/purchase/list",
      component: () =>
        import(
          "@/views/materialDesignDepartment/materialPurchase/list/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialPurchaseList",
        title: "材料采购管理",
        name: "pcMaterialPurchaseList",
        keepAlive: true,
      },
    },
    // {
    //   path: "inAndOut",
    //   redirect: "/materialManagement/inAndOut/account",
    //   meta: {
    //     title: "出入库管理",
    //     permissionCode: "pcMaterialInAndOut",
    //   },
    //   component: () => import("@/router/EmptyComponent.vue"),
    //   children: [

    //   ],
    // },
    {
      path: "/materialManagement/inAndOut/turnoverList",
      component: () =>
        import("@/views/materialDesignDepartment/inAndOut/turnover/list.vue"),
      meta: {
        permissionCode: "pcMaterialInAndOutOutTurnoverList",
        title: "材料库存台账",
        name: "pcMaterialInAndOutOutTurnoverList",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/inAndOut/turnoverDetail",
      component: () =>
        import("@/views/materialDesignDepartment/inAndOut/turnover/detail.vue"),
      meta: {
        permissionCode: "pcMaterialInAndOutOutTurnoverList",
        title: "材料出入库明细",
      },
    },
    {
      path: "/materialManagement/inAndOut/account",
      component: () =>
        import("@/views/materialDesignDepartment/inAndOut/account/index.vue"),
      meta: {
        permissionCode: "pcMaterialInAndOutAccountList",
        title: "材料出入库台账",
        name: "pcMaterialInAndOutAccountList",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/inAndOut/inTo/list",
      component: () =>
        import("@/views/materialDesignDepartment/inAndOut/inTo/list/index.vue"),
      meta: {
        permissionCode: "pcMaterialInAndOutIntoList",
        title: "材料入库管理",
        name: "pcMaterialInAndOutIntoList",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/inAndOut/inTo/create",
      component: () =>
        import(
          "@/views/materialDesignDepartment/inAndOut/inTo/create/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialInAndOutIntoEdit",
        title: "材料入库新增/编辑",
        state: "add",
        name: "pcMaterialInAndOutIntoForm",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/inAndOut/inTo/look",
      component: () =>
        import(
          "@/views/materialDesignDepartment/inAndOut/inTo/create/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialInAndOutIntoLook",
        title: "材料入库管理",
        state: "look",
        name: "pcMaterialInAndOutIntoForm",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/inAndOut/outTo/list",
      component: () =>
        import(
          "@/views/materialDesignDepartment/inAndOut/outTo/list/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialInAndOutOutToList",
        title: "材料出库管理",
        name: "pcMaterialInAndOutOutToList",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/inAndOut/outTo/details",
      component: () =>
        import(
          "@/views/materialDesignDepartment/inAndOut/outTo/details/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialInAndOutOutToList",
        title: "材料出库管理",
      },
    },
    {
      path: "/materialManagement/inAndOut/outTo/create",
      component: () =>
        import(
          "@/views/materialDesignDepartment/inAndOut/outTo/create/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialInAndOutOutToEdit",
        title: "材料出库新增/编辑",
        state: "add",
        name: "pcMaterialInAndOutOutToForm",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/inAndOut/outTo/look",
      component: () =>
        import(
          "@/views/materialDesignDepartment/inAndOut/outTo/create/index.vue"
        ),
      meta: {
        permissionCode: "pcMaterialInAndOutOutToLook",
        title: "材料出库管理",
        name: "pcMaterialInAndOutOutToForm",
        keepAlive: true,
        state: "look",
      },
    },
    // {
    //   path: "payment",
    //   redirect: "/materialManagement/payment/list",
    //   meta: {
    //     title: "材料付款管理",
    //     permissionCode: "pcMaterialManagementPayment",
    //     permissionRouterCode: [
    //       "pcMaterialManagementPayment",
    //       "pcWorkbenchPayment",
    //     ],
    //     name: "pcMaterialManagementPayment",
    //     keepAlive: true,
    //   },
    //   component: () => import("@/router/EmptyComponent.vue"),
    //   children: [

    //   ],
    // },
    {
      path: "/materialManagement/payment/list",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/list.vue"),
      meta: {
        title: "材料付款管理列表",
        permissionCode: "pcMaterialManagementPayment",
        permissionRouterCode: [
          "pcMaterialManagementPayment",
          "pcWorkbenchPayment",
        ],
        name: "pcMaterialManagementPayment",
        keepAlive: true,
      },
    },
    {
      path: "/materialManagement/payment/applyPro",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/progress/apply.vue"),
        meta: {
          title: "材料单包进度款-新增/编辑",
          permissionCode: "pcMaterialManagementPaymentProgressEdit",
          permissionRouterCode: [
            "pcMaterialManagementPayment",
            "pcWorkbenchPayment",
          ],
          name: "pcMaterialManagementPaymentProgressForm",
          keepAlive: true,
        },
    },
    {
      path: "/materialManagement/payment/applyPrepaidPro",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/progress/applyPrepaid.vue"),
        meta: {
          title: "材料单包预付款-新增/编辑",
          permissionCode: "pcMaterialManagementPaymentPrepaidEdit",
          permissionRouterCode: [
            "pcMaterialManagementPayment",
            "pcWorkbenchPayment",
          ],
          name: "pcMaterialManagementPaymentPrepaidForm",
          keepAlive: true,
        },
    },
    {
      path: "/materialManagement/payment/authPro",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/progress/auth.vue"),
        meta: {
          title: "材料单包进度款/预付款",
          permissionCode: "pcMaterialManagementPaymentProgressAuth",
          permissionRouterCode: [
            "pcMaterialManagementPayment",
            "pcWorkbenchPayment",
          ],
        },
    },
    {
      path: "/materialManagement/payment/applyScatterPro",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/scatterProgress/apply.vue"),
        meta: {
          title: "零星材料预付款新增/编辑",
          permissionCode: "pcMaterialManagementPaymentScatterProgressEdit",
          permissionRouterCode: [
            "pcMaterialManagementPayment",
            "pcWorkbenchPayment",
          ],
          name: "pcMaterialManagementPaymentScatterProgressForm",
          keepAlive: true,
        },
    },
    {
      path: "/materialManagement/payment/authScatterPro",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/scatterProgress/auth.vue"),
        meta: {
          title: "零星材料预付款",
          permissionCode: "pcMaterialManagementPaymentScatterProgressAuth",
          permissionRouterCode: [
            "pcMaterialManagementPayment",
            "pcWorkbenchPayment",
          ],
        },
    },
    {
      path: "/materialManagement/payment/applySet",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/settlement/apply.vue"),
        meta: {
          title: "材料单包结算款新增/编辑",
          permissionCode: "pcMaterialManagementPaymentSettlementEdit",
          permissionRouterCode: [
            "pcMaterialManagementPayment",
            "pcWorkbenchPayment",
          ],
          name: "pcMaterialManagementPaymentSettlementForm",
          keepAlive: true,
        },
    },
    {
      path: "/materialManagement/payment/authSet",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/settlement/auth.vue"),
      meta: {
        title: "材料单包结算款",
        permissionCode: "pcMaterialManagementPaymentSettlementAuth",
        permissionRouterCode: [
          "pcMaterialManagementPayment",
          "pcWorkbenchPayment",
        ],
      },
    },
    {
      path: "/materialManagement/payment/applyScatterSet",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/scatterSettlement/apply.vue"),
        meta: {
          title: "零星材料结算款新增/编辑",
          permissionCode: "pcMaterialManagementPaymentScatterSettlementEdit",
          permissionRouterCode: [
            "pcMaterialManagementPayment",
            "pcWorkbenchPayment",
          ],
          name: "pcMaterialManagementPaymentScatterSettlementForm",
          keepAlive: true,
        },
    },
    {
      path: "/materialManagement/payment/authScatterSet",
      component: () =>
        import("@/views/materialDesignDepartment/payMgt/scatterSettlement/auth.vue"),
      meta: {
        title: "零星材料结算款",
        permissionCode: "pcMaterialManagementPaymentScatterSettlementAuth",
        permissionRouterCode: [
          "pcMaterialManagementPayment",
          "pcWorkbenchPayment",
        ],
      },
    },
    // {
    //   path: "inquiry",
    //   redirect: "/materialManagement/inquiry/list",
    //   meta: {
    //     title: "材料询价管理",
    //     permissionCode: "pcWorkbenchInquiry",
    //   },
    //   component: () => import("@/router/EmptyComponent.vue"),
    //   children: [

    //   ],
    // },
    {
      path: "/materialManagement/inquiry/list",
      meta: {
        title: "材料询价列表",
        permissionCode: "pcWorkbenchInquiry",
        name: "pcWorkbenchInquiry",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/inquiry/list.vue"),
    },
    {
      path: "/materialManagement/inquiry/apply",
      meta: {
        title: "材料询价新增/修改",
        permissionCode: "pcWorkbenchInquiryEdit",
        name: "pcWorkbenchInquiryForm",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/inquiry/add.vue"),
    },
    {
      path: "/materialManagement/inquiry/auth",
      meta: {
        title: "材料询价审核",
        permissionCode: "pcWorkbenchInquiryAuth",
      },
      component: () =>
        import("@/views/materialDesignDepartment/inquiry/auth.vue"),
    },
    {
      path: "/materialManagement/report/inStorage",
      meta: {
        title: "材料入库单报表",
        permissionCode: "pcMaterialReportInStorage",
        name: "pcMaterialReportInStorage",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/report/inStorage/index.vue"),
    },
    {
      path: "/materialManagement/report/supplier",
      meta: {
        title: "供应商供应及支付汇总表",
        permissionCode: "pcMaterialReportSupplier",
        name: "pcMaterialReportSupplier",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/report/supplier/index.vue"),
    },
    {
      path: "/materialManagement/report/supplier/pay",
      meta: {
        title: "项目材料付款汇总表",
        permissionCode: "pcMaterialReportSupplierPay",
        name: "pcMaterialReportSupplierPay",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/report/supplier/pay.vue"),
    },
    {
      path: "/materialManagement/report/supplier/use",
      meta: {
        title: "项目材料使用汇总表",
        permissionCode: "pcMaterialReportSupplierUse",
        name: "pcMaterialReportSupplierUse",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/report/supplier/use.vue"),
    },
    {
      path: "/materialManagement/report/material",
      meta: {
        title: "项目材料分析表",
        permissionCode: "pcMaterialReportMaterial",
        name: "pcMaterialReportMaterial",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/report/material/index.vue"),
    },
    {
      path: "/materialManagement/report/use",
      meta: {
        title: "班组领用汇总表",
        permissionCode: "pcMaterialReportUse",
        name: "pcMaterialReportUse",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/report/use/index.vue"),
    },
    {
      path: "/materialManagement/report/useDetail",
      meta: {
        title: "班组领用明细表",
        permissionCode: "pcMaterialReportUseDetail",
        name: "pcMaterialReportUseDetail",
        keepAlive: true,
      },
      component: () =>
        import("@/views/materialDesignDepartment/report/use/detail.vue"),
    },
  ],
};
